<template>
    <div class="tw-my-8">
        <div class="tw-flex tw-space-x-6">
            <label class="tw-flex tw-items-center tw-cursor-pointer">
                <div class="tw-relative tw-w-5 tw-h-5">
                    <input
                        type="radio"
                        value="f"
                        v-model="selectedGender"
                        class="tw-appearance-none tw-absolute tw-w-full tw-h-full tw-border-2 tw-border-red-500 tw-rounded-full focus:tw-outline-none"
                    />
                    <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                        <div class="tw-w-3 tw-h-3 tw-bg-red-500 tw-rounded-full tw-opacity-0 tw-transition-opacity tw-duration-200" :class="{ 'tw-opacity-100': selectedGender === 'f' }"></div>
                    </div>
                </div>
                <span class="tw-ml-2">Frau</span>
            </label>
            <label class="tw-flex tw-items-center tw-cursor-pointer">
                <div class="tw-relative tw-w-5 tw-h-5">
                    <input
                        type="radio"
                        value="m"
                        v-model="selectedGender"
                        class="tw-appearance-none tw-absolute tw-w-full tw-h-full tw-border-2 tw-border-red-500 tw-rounded-full focus:tw-outline-none"
                    />
                    <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                        <div class="tw-w-3 tw-h-3 tw-bg-red-500 tw-rounded-full tw-opacity-0 tw-transition-opacity tw-duration-200" :class="{ 'tw-opacity-100': selectedGender === 'm' }"></div>
                    </div>
                </div>
                <span class="tw-ml-2">Herr</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "GenderSelector",
    data: () => ({
        selectedGender: '',
    }),
    watch: {
        selectedGender: function (val) {
            this.$store.commit('tour/setGender', val);
        }
    }
}
</script>